import 'foundation-sites/js/foundation/foundation';
import 'foundation-sites/js/foundation/foundation.dropdown';
import utils from '@bigcommerce/stencil-utils';

const SETUP_FEE_STORAGE_KEY = 'canterberrySetupFeeLinks';

const normalizeSetupFeeLinkEntry = entry => {
    if (typeof entry === 'string' || typeof entry === 'number') {
        const setupItemId = String(entry).trim();

        return setupItemId ? { setupItemId } : null;
    }

    if (!entry || typeof entry !== 'object') {
        return null;
    }

    const setupItemId = String(entry.setupItemId || entry.itemId || '').trim();

    return setupItemId ? { setupItemId } : null;
};

const normalizeSetupFeeLinkMap = entries => {
    const normalized = {};

    Object.entries(entries || {}).forEach(([parentItemId, entry]) => {
        const normalizedEntry = normalizeSetupFeeLinkEntry(entry);

        if (!normalizedEntry) {
            return;
        }

        normalized[String(parentItemId)] = normalizedEntry;
    });

    return normalized;
};

const readSetupFeeLinks = () => {
    try {
        const raw = window.localStorage.getItem(SETUP_FEE_STORAGE_KEY);
        return raw ? JSON.parse(raw) : {};
    } catch (error) {
        return {};
    }
};

const normalizeVisibleCartQuantity = (quantity, cartId) => {
    const parsedQuantity = Number(quantity) || 0;

    if (!cartId) {
        return Math.max(parsedQuantity, 0);
    }

    const links = readSetupFeeLinks();
    const cartLinks = normalizeSetupFeeLinkMap(links[String(cartId)] || {});
    const uniqueSetupFeeCount = new Set(Object.values(cartLinks).map(entry => entry.setupItemId)).size;

    return Math.max(parsedQuantity - uniqueSetupFeeCount, 0);
};

export const CartPreviewEvents = {
    close: 'closed.fndtn.dropdown',
    open: 'opened.fndtn.dropdown',
};

export default function (secureBaseUrl, cartId) {
    const loadingClass = 'is-loading';
    const $cart = $('[data-cart-preview]');
    const $cartDropdown = $('#cart-preview-dropdown');
    const $cartLoading = $('<div class="loadingOverlay"></div>');

    const $body = $('body');

    if (window.ApplePaySession) {
        $cartDropdown.addClass('apple-pay-supported');
    }

    $body.on('cart-quantity-update', (event, quantity) => {
        const displayQuantity = normalizeVisibleCartQuantity(quantity, cartId);

        $cart.attr('aria-label', (_, prevValue) => prevValue.replace(/\d+/, displayQuantity));

        if (!displayQuantity) {
            $cart.addClass('navUser-item--cart__hidden-s');
        } else {
            $cart.removeClass('navUser-item--cart__hidden-s');
        }

        $('.cart-quantity')
            .text(displayQuantity)
            .toggleClass('countPill--positive', displayQuantity > 0);

        $('.cart-quantity + .navUser-item-cartLabel').text(displayQuantity === 1 ? 'Item' : 'Items');

        if (utils.tools.storage.localStorageAvailable()) {
            localStorage.setItem('cart-quantity', quantity);
        }
    });

    $cart.on('click', event => {
        const options = {
            template: 'common/cart-preview',
        };

        // Redirect to full cart page
        //
        // https://developer.mozilla.org/en-US/docs/Browser_detection_using_the_user_agent
        // In summary, we recommend looking for the string 'Mobi' anywhere in the User Agent to detect a mobile device.
        if (/Mobi/i.test(navigator.userAgent)) {
            event.preventDefault();
            event.stopPropagation();

            const targetUrl = event.currentTarget && event.currentTarget.href
                ? event.currentTarget.href
                : $cart.attr('href');

            if (targetUrl) {
                window.location.assign(targetUrl);
            }

            return;
        }

        event.preventDefault();

        $cartDropdown
            .addClass(loadingClass)
            .html($cartLoading);
        $cartLoading
            .show();

        utils.api.cart.getContent(options, (err, response) => {
            $cartDropdown
                .removeClass(loadingClass)
                .html(response);
            $cartLoading
                .hide();
        });
    });

    let quantity = 0;

    if (cartId) {
        // Get existing quantity from localStorage if found
        if (utils.tools.storage.localStorageAvailable()) {
            if (localStorage.getItem('cart-quantity')) {
                quantity = Number(localStorage.getItem('cart-quantity'));
                $body.trigger('cart-quantity-update', quantity);
            }
        }

        // Get updated cart quantity from the Cart API
        const cartQtyPromise = new Promise((resolve, reject) => {
            utils.api.cart.getCartQuantity({ baseUrl: secureBaseUrl, cartId }, (err, qty) => {
                if (err) {
                    // If this appears to be a 404 for the cart ID, set cart quantity to 0
                    if (err === 'Not Found') {
                        resolve(0);
                    } else {
                        reject(err);
                    }
                }
                resolve(qty);
            });
        });

        // If the Cart API gives us a different quantity number, update it
        cartQtyPromise.then(qty => {
            quantity = qty;
            $body.trigger('cart-quantity-update', quantity);
        });
    } else {
        $body.trigger('cart-quantity-update', quantity);
    }
}
